var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { config } from "./Conf";
import { ballsColorsDecorator } from "./Decorators";
import { Board } from "./Board";
import { Ball } from "./Ball";
/**
 * Main class where it all starts
 */
var Area = /** @class */ (function () {
    function Area() {
        this.div = document.createElement("div");
        this.div.id = "mainDiv";
        this.gameInfo = document.createElement('div');
        this.gameInfo.id = "gameInfo";
        this.ballInfo = document.createElement("div");
        this.ballInfo.id = 'ballInfo';
        this.scoreDiv = document.createElement('div');
        this.scoreDiv.id = 'scoreDiv';
        this.score = 0;
        this.board = new Board(config.board_length, config.board_height);
        this.board.parent = this;
        this.ballSpawnerCount = config.ballSpawnerCount;
        this.ballPrevColor = new Array(this.ballSpawnerCount).fill(null).map(function (x) { return new Array(config.colors[Math.floor(Math.random() * config.colors.length)]); });
        this.init();
    }
    /** Initialization Area class */
    Area.prototype.init = function () {
        var _this = this;
        document.body.appendChild(this.div);
        this.gameInfo.appendChild(this.ballInfo);
        this.gameInfo.appendChild(this.scoreDiv);
        this.div.appendChild(this.gameInfo);
        this.div.appendChild(this.board.mainDiv);
        this.scoreDiv.innerHTML = "Score: " + this.score.toString();
        this.ballPrevColor.map(function (e) {
            var ball = new Ball(e);
            ball.addClass('prev');
            ball.removeClass('ball');
            _this.ballInfo.appendChild(ball.div);
        });
        this.ballManage();
    };
    Area.prototype.ballManage = function (joker) {
        var _this = this;
        if (joker === void 0) { joker = false; }
        this.board.createBalls(this.ballPrevColor);
        this.board.slideEffectBool = true;
        config.fastGame == false ? this.gameInfo.style.borderColor = 'red' : null;
        setTimeout(function () {
            _this.gameInfo.style.borderColor = 'white';
            _this.board.slideEffectBool = false;
            _this.board.boardScan();
            if (_this.board.fieldsList.flatMap(function (cV, i) { return cV.map(function (e, j) { return e; }); }).filter(function (e) { if (e.free) {
                return e;
            } }).length == 0) {
                _this.endGame();
            }
            ;
            _this.ballPrevColor = new Array(_this.ballSpawnerCount).fill(null).map(function (x) { return new Array(config.colors[Math.floor(Math.random() * config.colors.length)]); });
            _this.ballInfo.innerHTML = '';
            _this.ballPrevColor.map(function (e, i, a) {
                var ball;
                if (i == 0 && joker == true) {
                    ball = new Ball(__spreadArray([], config.colors, true));
                    a[i] = __spreadArray([], config.colors, true);
                }
                else {
                    ball = new Ball(e);
                }
                ball.addClass('prev');
                ball.removeClass('ball');
                _this.ballInfo.appendChild(ball.div);
            });
        }, config.fastGame ? 1 : 1000);
    };
    /** @inheritdoc */
    Area.prototype.addScore = function (val) {
        this.score += val;
        this.scoreDiv.innerHTML = "Score: " + this.score.toString();
    };
    /** @inheritdoc */
    Area.prototype.endGame = function () {
        var _this = this;
        var overlay = document.createElement('div');
        overlay.id = 'overlay';
        document.body.appendChild(overlay);
        overlay.style.opacity = "0";
        var endGameInfo = document.createElement('div');
        endGameInfo.id = 'endGameInfo';
        overlay.appendChild(endGameInfo);
        var spanTitle = document.createElement('span');
        spanTitle.id = "spanTitle";
        spanTitle.innerHTML = "YOU LOSE";
        endGameInfo.appendChild(spanTitle);
        var spanScoreTitle = document.createElement('span');
        spanScoreTitle.id = "spanScoreTitle";
        spanScoreTitle.innerHTML = "Score";
        endGameInfo.appendChild(spanScoreTitle);
        var spanScore = document.createElement('span');
        spanScore.id = "spanScore";
        spanScore.innerHTML = "" + this.score;
        endGameInfo.appendChild(spanScore);
        var btn = document.createElement('button');
        btn.classList.add('btn');
        btn.innerHTML = 'RESTART';
        endGameInfo.appendChild(btn);
        btn.onclick = function () {
            document.body.innerHTML = '';
            _this.div.innerHTML = '';
            _this.board = new Board(config.board_length, config.board_height);
            _this.board.parent = _this;
            _this.score = 0;
            _this.init();
        };
        setTimeout(function () { overlay.style.opacity = "1"; }, 10);
    };
    __decorate([
        ballsColorsDecorator,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Area.prototype, "ballManage", null);
    return Area;
}());
export { Area };
